import React from 'react';
import { Button, Modal } from 'react-bootstrap';

export const NeedAssistanceModal = ({ show, onHide }) => (
  <Modal dialogClassName="login-assistance-modal" centered show={show} onHide={onHide}>
    <Modal.Header closeButton>
      <Modal.Title>Need Assistance?</Modal.Title>
    </Modal.Header>
    <Modal.Body>
      <p className="mb-0">
        Contact DonorsTrust at{' '}
        <a href="mailto:dtgrants@donorstrust.org">dtgrants@donorstrust.org</a> or call{' '}
        <a href="tel:+17035353563">703 535 3563</a>.
      </p>
    </Modal.Body>
    <Modal.Footer>
      <Button variant="secondary" onClick={onHide}>
        Close
      </Button>
    </Modal.Footer>
  </Modal>
);
